import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=6fa7c20a&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=6fa7c20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7c20a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VProgressLinear,VToolbar,VToolbarTitle})
